var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "176.4px",
    height: "23px",
    viewBox: "0 0 176.4 23",
    style: {
      enableBackground: "new 0 0 176.4 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#243640;}\r\n\t.st1{fill:#689EB9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.7,20.3L24.5,0c-0.3,0-0.6,0.1-0.8,0.2L1.5,10.6c-0.2,0.1-0.3,0.2-0.5,0.3L20.7,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,22.7v-0.3L0,12.7c0,0.5,0,0.9,0.2,1.3l4,8.7L20.2,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37,22.7L27.2,1.6C27,1.3,26.8,1,26.5,0.8l-4.1,21.9L37,22.7L37,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.6,12.6c0,1.3-1.1,2.4-2.4,2.4c-0.1,0-0.2,0-0.3,0h-2.7v-4.8h2.7C80.5,10.2,81.6,11,81.6,12.6L81.6,12.6z    M85.1,12.5L85.1,12.5c0-3.2-2.2-5.4-6-5.4h-6.3v15.6h3.4V18h2.6C82.3,18,85.1,16.1,85.1,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.2,14.7c0.1,2.6-1.9,4.7-4.5,4.8c-0.1,0-0.1,0-0.2,0c-2.6,0-4.7-2.1-4.7-4.8c0,0,0-0.1,0-0.1l0,0   c-0.1-2.6,1.9-4.7,4.5-4.8c0.1,0,0.1,0,0.2,0c2.6,0,4.7,2.1,4.7,4.8C99.2,14.6,99.2,14.6,99.2,14.7z M102.8,14.7L102.8,14.7   c-0.2-4.6-4-8.2-8.6-8c-4.4,0.2-7.8,3.6-8,8l0,0c0.2,4.6,4,8.2,8.6,8C99.1,22.5,102.6,19,102.8,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.3,22.7c3.4,0,5.7-1.7,5.7-4.8l0,0c0-2.7-1.8-3.9-4.9-4.7c-2.7-0.7-3.4-1-3.4-2l0,0c0-0.8,0.7-1.4,2-1.4   c1.5,0.1,2.9,0.6,4.1,1.5l1.8-2.6c-1.6-1.3-3.7-2-5.8-2c-3.2,0-5.4,1.9-5.4,4.7l0,0c0,3.1,2,4,5.2,4.8c2.6,0.7,3.1,1.1,3.1,2l0,0   c0,0.9-0.8,1.5-2.2,1.5c-1.7,0-3.4-0.7-4.7-1.9l-2,2.4C105.5,21.9,107.8,22.8,110.3,22.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "121.9,22.7 125.3,22.7 125.3,10.3 130,10.3 130,7.1 117.1,7.1 117.1,10.3 121.9,10.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.8,18c0,1.2-0.9,1.7-2.4,1.7h-4.1v-3.4h4C141,16.3,141.8,16.9,141.8,18L141.8,18z M140.9,11.8    c0,1.2-1,1.6-2.5,1.6h-3.2v-3.3h3.4C140.1,10.1,140.9,10.7,140.9,11.8L140.9,11.8z M142.3,14.6c1.3-0.6,2-1.9,2-3.4l0,0    c0-1-0.4-2-1.1-2.6c-1.1-1-2.6-1.5-4.1-1.4H132v15.5h7.4c3.5,0,5.8-1.4,5.8-4.3l0,0C145.2,16.3,144.1,15.3,142.3,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.9,14.7c0.1,2.6-1.9,4.7-4.5,4.8c-0.1,0-0.1,0-0.2,0c-2.6,0-4.7-2.1-4.7-4.8c0,0,0-0.1,0-0.1l0,0    c-0.1-2.6,1.9-4.7,4.5-4.8c0.1,0,0.1,0,0.2,0c2.6,0,4.7,2.1,4.7,4.8C158.9,14.6,158.9,14.6,158.9,14.7z M162.5,14.7L162.5,14.7    c-0.2-4.6-4-8.2-8.6-8c-4.4,0.2-7.8,3.6-8,8l0,0c0.2,4.6,4,8.2,8.6,8C158.9,22.5,162.3,19,162.5,14.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "172.2,7.1 168.9,12.2 165.7,7.1 161.6,7.1 166.9,14.8 161.4,22.7 165.3,22.7 168.8,17.4 172.3,22.7    176.4,22.7 170.9,14.7 176.1,7.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49,23c4.2,0,6.8-2.3,6.8-7V7.2h-3.5v8.9c0,2.5-1.3,3.7-3.4,3.7s-3.4-1.3-3.4-3.8V7.2h-3.4v8.9    C42.2,20.7,44.8,23,49,23"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "57.5,22.7 60.9,22.7 60.9,17.9 62.7,16.1 67.5,22.7 71.7,22.7 65,13.7 71.4,7.1 67.2,7.1 60.9,13.9    60.9,7.1 57.5,7.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2073b43dbb01de56dbcaa9cd5b07501f.svg";
export { ForwardRef as ReactComponent };